import { useMutation } from "@tanstack/react-query";
import { actions, isInputError } from "astro:actions";
import Link from "astro-typesafe-routes/link/react";

import { Alert } from "~/components/Alert";
import { DialogBody } from "~/components/DialogBody";
import { DialogFooter } from "~/components/DialogFooter";
import { DialogTitle } from "~/components/DialogTitle";
import { TextField } from "~/components/TextField";

import { PasswordField } from "./PasswordField";

export const LoginForm: React.FC<{
  children: React.ReactElement;
  formData: FormData;
}> = ({ children, formData }) => {
  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationFn: actions.auth.login.orThrow,
    onSuccess: () => {
      window.location.reload();
    },
  });
  return (
    <form
      autoComplete="off"
      className="contents"
      onSubmit={(event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        mutate(formData);
      }}
    >
      {children}
      <DialogBody className="space-y-4">
        <div className="space-y-2">
          <DialogTitle>Nice to see you again!</DialogTitle>
          <p>Enter your email and password below to access your account.</p>
        </div>
        {error && !isInputError(error) && (
          <Alert type="error">{error.message}</Alert>
        )}
        <TextField
          required
          autoFocus
          label="Email"
          type="email"
          name="email"
          defaultValue={formData.get("email")?.toString()}
          error={isInputError(error) ? error.fields.email?.[0] : undefined}
        />
        <PasswordField />
        <p className="text-sm">
          Forgot your password?{" "}
          <Link to="/forgot-password" className="link">
            Click here
          </Link>{" "}
          to reset it.
        </p>
      </DialogBody>
      <DialogFooter>
        <button
          disabled={isPending || isSuccess}
          type="submit"
          className="btn btn-secondary btn-block"
        >
          Log in
        </button>
      </DialogFooter>
    </form>
  );
};
